<template>
    <div class="main">

        <b-navbar toggleable="lg" type="dark" variant="dark">
            <b-navbar-brand class="text-light" href="#">LabyHelp Addon</b-navbar-brand>
            -
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item style="color: #c2c2c2" href="#">
                        <router-link style="color: #c2c2c2" to="/home">Home</router-link>
                    </b-nav-item>
                    <b-nav-item to="/home#features" style="color: #c2c2c2">Features
                    </b-nav-item>
                    <b-nav-item href="#features" style="color: #c2c2c2" to="/support">
                        Support
                    </b-nav-item>
                    <b-nav-item href="#features" style="color: #ffffff" to="/support">
                        <router-link style="color: #ffffff" to="/home">Creator Program</router-link>
                    </b-nav-item>
                </b-navbar-nav>

                <!-- Right aligned nav items -->

            </b-collapse>
        </b-navbar>

        <br/>
        <br/>

        <h1 class="text-dark display-title"><strong>Du bist ein <em>Content Creator</em>?</strong>
        </h1>


        <div class="container" id="creator">

            <br/>

            <h2 class="text-normal-title">
                <fai style="color:black;" :icon="['fas', 'gamepad']" size="1x"/>
                Content-Creator
            </h2>

            <div class="card">
                <p class="text-dark text-normal"> Du bist <strong style="color: #607ec2">YouTube Creator oder
                    Streamer</strong> und findest das <em>LabyHelp Addon</em> Perfekt!
                    <br/>
                    Bewirb dich jetzt als <code>LabyHelp Creator</code> und erhalte den exklusiven Creator Rang</p>

                <br/>

                <p style="color: gray">Erstelle Giveaways für deine Community, binde deine Community ins Addon mit ein und viele weitere coole Features</p>
            </div>


            <h2 class="text-normal-title">
                <em>Interesse geweckt?</em>
            </h2>
            <b-button size="lg" href="mailto:crapply@labyhelp.de">Bewerben</b-button>

            <br/>
            <br/>
            <br/>
            <br/>


        </div>

        <div class="end" style="background-color: #e0e0e0">
            <br/>

            <h1 class="text-dark"><strong>Du hast weitere <em>Fragen</em> zum Creator Program?</strong></h1>
            <p class="text-title text-dark">Dann hast du hier eine weitere Kontakt Möglichkeit</p>

            <br/>
            <b-button href="mailto:support@labyhelp.de"
                      title="download labyhelp addon" pill type="button" class="btn btn-dark btn-lg">
                <strong>Support</strong>
            </b-button>
            <br/>
            <br/>
            <br/>

        </div>


        <div class="footer">
            <p class="align-text-bottom">
                <router-link style="color: white" to="/support">Support</router-link>
                -
                <a style="color: white"
                   href="https://labyhelp.de/download" >Download</a>
                -
                <a style="color: white" href="https://discord.gg/PBqQT9C">Discord</a>
                -
                <a style="color: white" href="/home">Home</a>
                -
                <router-link style="color: white" to="/apply">Apply</router-link>

                -
                <router-link style="color: white" to="/rules">Regeln</router-link>
                <br/>
                © LabyHelp 2020
            </p>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'labyaddon'
    }

</script>